const createWidgetFactory = require('components-framework/widget/create_widget_factory');
const isMobile = Odigeo.SessionScope.flow === 'mobile';

module.exports = createWidgetFactory({
    name: 'baggage_passenger',
    viewClass: isMobile ? require('./view.mobile') : require('./view.desktop'),
    modelClass: require('./model'),
    methods: {},
});
